import {FLEETINFO} from '../actiontype'
import request from '@/utils/request'
import {fleetInfoApi} from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetinfoAction = () => {
  const action = (data) => (
    {
      type: FLEETINFO,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.get(fleetInfoApi,{},{
        ...inlineSign
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}